import { QueryClient, QueryClientProvider as ReactQueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import type React from 'react';

const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			retry: false,
			refetchOnWindowFocus: false,
		},
	},
});

export const QueryClientProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
	return (
		<ReactQueryClientProvider client={queryClient}>
			<ReactQueryDevtools />
			{children}
		</ReactQueryClientProvider>
	);
};
